import { yupResolver } from '@hookform/resolvers/yup';
import { DialogActions, DialogContent, Divider } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import StyledContainedButton from '../Styled/StyledContainedButton';
import StyledInput from '../Styled/styledInput';
import StyledTextArea from '../Styled/StyledTextArea';
import StyledTextButton from '../Styled/StyledTextButton';
import VolunteeringOpportunityModel from './volunteeringOpportunityModel';

const schema = yup.object().shape({
  effort: yup
    .number()
    .required('Effort is required')
    .typeError('Effort must be a number')
    .min(1, 'Effort must be at least 0.5 hours')
    .max(
      100,
      'That is too much effort. Consider splitting and logging separately.'
    ),
  notes: yup.string().required('Please enter some notes about your effort.'),
});

function VolunteeringEffortForm(props) {
  const { onSubmit, onClose, opportunity = null } = props;
  const {
    register,
    getValues,
    handleSubmit,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const onFormSubmit = () => {
    if (isValid && isDirty) {
      const data = getValues();
      data.effort = Number(data.effort);
      onSubmit(data);
    }
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <DialogContent>
        <Stack spacing={2}>
          <StyledInput
            placeholder="Effort in Hours"
            width="100%"
            register={register('effort')}
            errorMessage={errors.effort?.message || ''}
          />

          <StyledTextArea
            {...register('notes')}
            rows="4"
            autoFocus
            placeholder="Notes"
          />
          <Typography variant="caption" color="error">
            {errors && errors.notes?.message}
          </Typography>
        </Stack>
      </DialogContent>
      <Divider variant="middle" />
      <DialogActions>
        <StyledTextButton type="button" onClick={onClose}>
          <Typography variant="button">Cancel</Typography>
        </StyledTextButton>
        <StyledContainedButton disabled={!isDirty || !isValid} type="submit">
          Submit
        </StyledContainedButton>
      </DialogActions>
    </form>
  );
}

VolunteeringEffortForm.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  opportunity: VolunteeringOpportunityModel,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default VolunteeringEffortForm;
